const MEMO_SEEN_KEY = "wizmate.memo_seen.v1";

export function readLastSeenMemoId(): string | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(MEMO_SEEN_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const id = parsed?.id;
    return typeof id === "string" && id.trim() ? id.trim() : null;
  } catch {
    return null;
  }
}

export function writeLastSeenMemoId(id: string): void {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(MEMO_SEEN_KEY, JSON.stringify({ id }));
}
